import { COMMUNITIES_APIS } from "libs/apis/communities.api";
import { USER_APIS } from "libs/apis/users.api";

const useCommunities = () => {
  const getCommunities = async (
    setData: Function,
    queryParams: any = {},
    setPagination?: Function
  ) => {
    const response = await COMMUNITIES_APIS.getCommunities(queryParams);
    const { status = false, data = [] } = response || {};
    if (status) {
      setData(data.content);
      setPagination((prev) => ({
        ...prev,
        count: data.totalElements
      }));
      
    }
  };

  const getUserById = async (userId: number, setData: Function) => {
    const response = await USER_APIS.getUserById(userId);
    const { status = false, data = {} } = response || {};
    if (status) {
      setData(data);
    }
  };

  return {
    getCommunities,
    getUserById,
  };
};

export default useCommunities;
